import Swiper from "swiper";

/**
 * Init function for building all slides base on
 * className and configuration details
 */
export default class {
  constructor(configs) {
    configs.forEach(({ elements, details, bindEvents }) => {
      elements.forEach((el) => {
        if (el.querySelectorAll(".swiper-slide").length <= 1) return;

        const swiper = new Swiper(el, details(el));
        if (bindEvents) {
          bindEvents(el, swiper);
        }
      });
    });
  }
}
